import request from '@/helpers/customAxios'

export interface UserNotExpiredListRes {
    code: number
    data: UserNotExpiredItem[]
    desc: string
}
export interface NotExpiredItemFile {
    chunkNum: number
    compress: true
    createTime: number
    createUser: string
    id: string
    identifier: string
    isFile: true
    level: number
    name: string
    number: number
    oldId: number
    parentId: string
    path: string
    powers: number[]
    size: number
    sourceId: string
    topId: string
    type: string
    unzip: true
    unzipTarget: string
    updateTime: number
    updateUser: string
    userId: string
}
export interface UserNotExpiredItem {
    createTime: string
    createUserId: string
    expireTime: string
    file: NotExpiredItemFile
    fileList: NotExpiredItemFile[]
    fileId: string
    fileSize: number
    id: string
    isFile: true
    service: number
    shareIdentify: string
    shareUserList: string[]
    surplusMillis: number
    type: number
    updateTime: string
    url: string
}
export async function getUserNotExpiredList(): Promise<UserNotExpiredListRes> {
    return request.get('/api/getUserNotExpiredList')
}
